import React from 'react';

const Inventory = () => {
    return (
        <div>
            this is the Inventory pages
        </div>
    );
};

export default Inventory;